
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indextyTpIKl_45AoxjYiNQQPA8nGnB6kbm4wwueT73R83up7gMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/index.vue?macro=true";
import { default as logoutVSPOvJbyXcqimX5j1f2SW4oFPE6_ddMGn_45aDB3FRaD4Meta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/logout.vue?macro=true";
import { default as busquedahVmQ_45StakGqx1F2S9xh2Xk58psOnAdaZdnJ5QR8n0tgMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/busqueda.vue?macro=true";
import { default as _91_46_46_46slug_93vXc7ycRYyTCuDxX1_Kq_z4fB7sSV6INGoPuRmUDb7C4Meta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/[...slug].vue?macro=true";
import { default as indexXJRzcLGu7Alk26_45nJDc8K8Cydrql3EcgKXinDZnR9HgMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/compra/index.vue?macro=true";
import { default as crear_45cuenta3hKOfWcdjnpNljgGukLJN_45e8sszSaymh1NOt_453OgwVsMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/crear-cuenta.vue?macro=true";
import { default as _91id_9376OhzBirHWZgHIe6t7AoSWE1aTllG1O_45NRBhOTAyarQMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/encuestas/[id].vue?macro=true";
import { default as iniciar_45sesionBfC9d0KZp5ePzKktqcU3f2pJa6msRPaVUeNHJfY_457SUMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/iniciar-sesion.vue?macro=true";
import { default as indexc0gvZ3DLxVehzJGdBbQgJY3BPyLMQio6kGp6pjAIk7oMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/tarifario/index.vue?macro=true";
import { default as acceso83tB4Yt0EMcEAgDlPzMua8LToyGqT9VbCI4XTSjr1xQMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/tarifario/acceso.vue?macro=true";
import { default as indexZHr5tGjX7lX9xWiWihQO1GlOut8Ny7gML7wL1un6EggMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/blog/[blogSlug]/index.vue?macro=true";
import { default as iniciar_45sesion2UJZqUzTm0VZoLrfAJgx6_biCM2sCDXF6reCuEyo0X4Meta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/compra/iniciar-sesion.vue?macro=true";
import { default as _91token_93bbvabg7nl_FrKbCNZ3zCfgzypwiUQABYbTxcZeGxi9MMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/activar-cuenta/[token].vue?macro=true";
import { default as perfilGQt3YnvAmaKL2GswEZ9iDjgFHS9AqUfbleECaS4HsoQMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/zona-de-cliente/perfil.vue?macro=true";
import { default as _91productSlug_93r3ehL4yogMx6q98GReF8zNaLh6gC_o_U_b0jXOlu24kMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/tarifario/[productSlug].vue?macro=true";
import { default as confirma_45tu_45pedidotDqy26uIMyJlnopZnQ3NuNa1hPsfMZFitkgZtu_SIdEMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/compra/confirma-tu-pedido.vue?macro=true";
import { default as envio_45y_45facturacionTlgStxCOJIHQ47KMLq4QrHQw2DmLHESOmaFq9qS4unAMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/compra/envio-y-facturacion.vue?macro=true";
import { default as solicitar_45nueva_45contrasena9Xo01uu0UQAAWdL7ZvBw_45wSbBigb1OLH8_456mUcNL2jUMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/solicitar-nueva-contrasena.vue?macro=true";
import { default as index6u0ff82rw4Rdhz6EYubGvFaA1u5G8aWLtVMA9BxTdd8Meta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/tienda/[categorySlug]/index.vue?macro=true";
import { default as _91token_93tYfauGf96jZEaTH6mDb_nqAfbte5FP2TOadkPN8mZR0Meta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/modificar-contrasena/[token].vue?macro=true";
import { default as indexTvbe3gSHzHcemHrWGg8jpY9ax9FLIgc3dOhzeynn_45Z8Meta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/zona-de-cliente/cursos/index.vue?macro=true";
import { default as _91articleSlug_93uKiOG51CtGmsCffhksZqaKcLgXDa_ZUisIikgvERdqMMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/blog/[blogSlug]/[articleSlug].vue?macro=true";
import { default as indexpEgfCjxCmwMRVU4Y17NPxBjdhPWc2IMkbK8Cy5rL1EIMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/zona-de-cliente/pedidos/index.vue?macro=true";
import { default as _91courseId_93fUxDT39GcHh8TlJ0dFC68zoXmrwl5dlEsor3McztKGcMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/zona-de-cliente/cursos/[courseId].vue?macro=true";
import { default as _91productSlug_93dJUpgIhjF5Wj7InbemKEGzFuJIN8LMHFzSgpP9l2IuAMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/tienda/[categorySlug]/[productSlug].vue?macro=true";
import { default as _91orderNumber_93_45LbsuAgmWqNGmjx3Z_45iTfz9NghLqU1V_T_mYFap0zNkMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/compra/pedido-realizado/[orderNumber].vue?macro=true";
import { default as _91productSlug_93tu8Zc4pkhGQzi4nq_45BHcVNwiRp_45P7LJKDBRBH79PYVMMeta } from "/home/jmcastillo/projects/external/frontend-base/src/pages/cursos-online-para-profesionales/[productSlug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/logout.vue")
  },
  {
    name: "busqueda",
    path: "/busqueda",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/busqueda.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/[...slug].vue")
  },
  {
    name: "compra",
    path: "/compra",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/compra/index.vue")
  },
  {
    name: "crear-cuenta",
    path: "/crear-cuenta",
    meta: {"middleware":"only-not-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/crear-cuenta.vue")
  },
  {
    name: "encuestas-id",
    path: "/encuestas/:id()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/encuestas/[id].vue")
  },
  {
    name: "iniciar-sesion",
    path: "/iniciar-sesion",
    meta: {"middleware":"only-not-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/iniciar-sesion.vue")
  },
  {
    name: "tarifario",
    path: "/tarifario",
    meta: {"middleware":"only-price-table-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/tarifario/index.vue")
  },
  {
    name: "tarifario-acceso",
    path: "/tarifario/acceso",
    meta: {"middleware":"only-not-price-table-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/tarifario/acceso.vue")
  },
  {
    name: "blog-blogSlug",
    path: "/blog/:blogSlug()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/blog/[blogSlug]/index.vue")
  },
  {
    name: "compra-iniciar-sesion",
    path: "/compra/iniciar-sesion",
    meta: {"middleware":"only-not-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/compra/iniciar-sesion.vue")
  },
  {
    name: "activar-cuenta-token",
    path: "/activar-cuenta/:token()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/activar-cuenta/[token].vue")
  },
  {
    name: "zona-de-cliente-perfil",
    path: "/zona-de-cliente/perfil",
    meta: {"middleware":"only-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/zona-de-cliente/perfil.vue")
  },
  {
    name: "tarifario-productSlug",
    path: "/tarifario/:productSlug()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/tarifario/[productSlug].vue")
  },
  {
    name: "compra-confirma-tu-pedido",
    path: "/compra/confirma-tu-pedido",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/compra/confirma-tu-pedido.vue")
  },
  {
    name: "compra-envio-y-facturacion",
    path: "/compra/envio-y-facturacion",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/compra/envio-y-facturacion.vue")
  },
  {
    name: "solicitar-nueva-contrasena",
    path: "/solicitar-nueva-contrasena",
    meta: {"middleware":"only-not-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/solicitar-nueva-contrasena.vue")
  },
  {
    name: "tienda-categorySlug",
    path: "/tienda/:categorySlug()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/tienda/[categorySlug]/index.vue")
  },
  {
    name: "modificar-contrasena-token",
    path: "/modificar-contrasena/:token()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/modificar-contrasena/[token].vue")
  },
  {
    name: "zona-de-cliente-cursos",
    path: "/zona-de-cliente/cursos",
    meta: {"middleware":"only-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/zona-de-cliente/cursos/index.vue")
  },
  {
    name: "blog-blogSlug-articleSlug",
    path: "/blog/:blogSlug()/:articleSlug()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/blog/[blogSlug]/[articleSlug].vue")
  },
  {
    name: "zona-de-cliente-pedidos",
    path: "/zona-de-cliente/pedidos",
    meta: {"middleware":"only-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/zona-de-cliente/pedidos/index.vue")
  },
  {
    name: "zona-de-cliente-cursos-courseId",
    path: "/zona-de-cliente/cursos/:courseId()",
    meta: {"middleware":"only-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/zona-de-cliente/cursos/[courseId].vue")
  },
  {
    name: "tienda-categorySlug-productSlug",
    path: "/tienda/:categorySlug()/:productSlug()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/tienda/[categorySlug]/[productSlug].vue")
  },
  {
    name: "compra-pedido-realizado-orderNumber",
    path: "/compra/pedido-realizado/:orderNumber()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/compra/pedido-realizado/[orderNumber].vue")
  },
  {
    name: "cursos-online-para-profesionales-productSlug",
    path: "/cursos-online-para-profesionales/:productSlug()",
    component: () => import("/home/jmcastillo/projects/external/frontend-base/src/pages/cursos-online-para-profesionales/[productSlug].vue")
  }
]